module.exports = {
  InteractiveItem: {
    PluginName: "Elemento interactivo",
    Empty: "No se encontró el elemento interactivo",
    Edit: "Editar",
    AiEdit: "Editar con IA",
    AiEditHint:
      "Di qué debe cambiar: el aspecto, el contenido o el comportamiento. Se aplica sobre el elemento actual.",
    AiEditPlaceholder:
      "Ej.: haz las tarjetas más coloridas · añade una pregunta · tocar en vez de arrastrar",
    AiEditRunning: "Aplicando el cambio",
    AiEditApply: "Aplicar",
    AiEditUnavailable:
      "Este elemento no se puede editar con IA (no tiene fuente). Puedes generar uno nuevo.",
    EditHint: "Edita el contenido — no hace falta regenerar",
    TryOn: "Probar",
    TryOff: "✓ Prueba activa",
    TryOnHint: "Actívalo para jugar la actividad",
    TryOffHint: "Desactívalo para mover la caja",

    ModalTitle: "Añadir un elemento interactivo",
    GoalQuestion: "¿Qué quieres conseguir?",
    Suggestions: "Tres sugerencias",
    ShowAll: "Ver todos los tipos",
    ModeWrite: "Escribir un prompt",
    ModeNarration: "Desde la narración",
    NoNarration: "Esta escena no tiene narración",
    NeedInput: "Esta escena no tiene narración — escribe un tema arriba.",
    PromptPlaceholder: "¿Sobre qué? Ej.: cómo usar un extintor",
    PromptOverride: "Otro tema en lugar de la narración (opcional)",
    AccentColor: "Color principal",
    AccentColorNote: "Las superficies, tonos y degradados se derivan de él",
    CustomColor: "Color personalizado",
    AllTypes: "Todos los tipos",
    Thinking: "Leyendo la narración…",
    Generating: "Escribiendo la actividad",
    GeneratingMeta: "Puede tardar unos minutos — puedes cerrar la ventana, el trabajo continúa.",
    Again: "Probar otra cosa",
    Add: "Añadir a la escena",
    Scored: "puntuable",
    Unscored: "sin puntuación",
    SeeExample: "Ver un ejemplo",
    ExampleTag: "ejemplo",
    ExampleHint:
      "Una salida realmente generada — pruébala. El contenido es de relleno; esta es la forma que producirá tu narración.",

    EditorHint: "Cambia el contenido aquí — sin regenerar y sin gastar créditos.",
    Apply: "Aplicar",
    AddRow: "Añadir",
    MinRows: "No puede haber menos",
    ModelAuto: "Automático (Sonnet 5.5)",
    ModelSonnet: "Sonnet 5.5",
    ModelOpus: "Opus 5.5",
  },
};
